import { memo } from "react";
import BasicSensorChart from "./BasicSensorChart";
import styledConst from "styles";
import { CustomEChartParams } from "types/Charts";
import { get } from "lodash";
import { UnknownDevice } from "constant";
import { formattedChartValue, formatValueWithUnit } from "utils/functions";

function SingleSensorChart(props: any) {
    return (
        <BasicSensorChart
            {...{
                ...props,
                customEChartData: ({
                    liveData,
                    liveTime,
                    liveDate,
                    sensorUnit,
                    min,
                    max,
                    accuracy,
                    sensorType,
                    chart,
                }: CustomEChartParams) => {
                    const _formattedChartValue = (value: any) => {
                        return formattedChartValue({
                            sensorAccuracy: accuracy,
                            value,
                        });
                    };

                    let subTitle = sensorType;
                    if (chart === "COMBINED") {
                        subTitle += " - combined data";
                    }

                    return [
                        {
                            path: "title.subtext",
                            value: `{s6|${subTitle}}\n{s2|${formatValueWithUnit(
                                Number.isNaN(Number(liveData)) ? "-" : _formattedChartValue(liveData),
                                sensorUnit ?? ""
                            )}} {s5|    Min/Max} {s3| ${formatValueWithUnit(
                                `${Number.isNaN(min) ? "-" : _formattedChartValue(min)}/${Number.isNaN(max) ? "-" : _formattedChartValue(max)}`,
                                sensorUnit || ""
                            )}}\n{s1|${liveDate + " " + liveTime}}`,
                        },
                    ];
                },
                customEChartStyle: (chartColor: string) => {
                    return [
                        {
                            path: "title.subtextStyle.rich",
                            value: {
                                s1: {
                                    color: styledConst.Primary_Blue_4,
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: 14,
                                    height: 25,
                                },
                                s2: {
                                    color: chartColor,
                                    fontSize: 22,
                                    fontWeight: "bold",
                                },
                                s3: {
                                    color: "white",
                                    fontSize: 15,
                                    fontFamily: "Roboto",
                                    height: 25,
                                },
                                s4: {
                                    fontSize: 6,
                                },
                                s5: {
                                    color: styledConst.Primary_Blue_4,
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: 15,
                                    height: 25,
                                },
                                s6: {
                                    color: styledConst.Primary_Blue_4,
                                    fontFamily: "Roboto",
                                    fontWeight: 400,
                                    fontSize: 14,
                                    height: 25,
                                },
                            },
                        },
                    ];
                },
                displayName: (chartState) => {
                    return get(
                        chartState,
                        "sensorConfigRes.sensor_name",
                        UnknownDevice
                    );
                },
                onDelete: props.handleOnChangeDashboardUUID,
            }}
        />
    );
}

export default memo(SingleSensorChart);
